export const en = {
    'common': {
        'warn': 'Info',
        'success': 'Success',
        'ok': 'OK',
        'cancle': 'Cancle',
        'modify': 'Modify',
        'delete': 'Delete',
        'error': 'Error',
        'loading': 'Loading...',
        'your-position': '',
        'home-page': 'Home Page',
        'search': 'Search',
        'print': 'Print',
        'fold': 'Fold',
        'clear': 'Clear',
        'search-advanced': 'Search Advanced',
        'export-excel': 'Export Excel',
        'print-pdf': 'Print',
        'unfold': 'Unfold',
        'fold-all': 'Fold All',
        'unfold-all': 'Unfold All',
        'collapse': 'Collapse',
        'no-data': 'Sorry, no data',
        'authentication-error': 'Authentication Error',
        'request-error': 'Request Error',
        'start-date': 'Start Date',
        'end-date': 'End Date',
        'sort': 'Sort',
        'asc': 'Asc',
        'desc': 'Desc',
        'unknown-error': 'Unknown Error',
        'setup-column': 'Setup',
        'setup-save': 'Save',
        'setup-width': 'col width',
        'purchase-type': 'Purchase Type',
        'purchase-date': 'Purchase Date',
        'download': 'Download',
        'submit': 'Submit',
        'back': 'Back',
        'extension': 'extensions',
        'operate': 'operate',
        'edit': 'edit',
        'please-select': 'Please Select',
        'none-data': 'Sorry, no data',
        'save': 'Save',
        '备注': 'remark',
        'inquiry-publicly': 'Inquiry publicly',
        'supplier-registration': 'Supplier Registration',
        'contact-us': 'contact us',
        'name-tip': 'Please enter user name!',
        'no-name': 'The user name does not exist!',
        'email-tip': 'Please enter email!',
        'email-error': 'The mailbox format is not valid!',
        'account-login': 'The account login',
        'forget-password': 'forget the password',
        'enter-account': 'Please enter account',
        'enter-password': 'Please enter password',
        'password-again': 'Please enter your password again',
        'password-different': 'The two passwords did not match',
        'get-code': 'get Code',
        'confirm-modification': 'confirm modification',
        'account': 'account no',
        'code': 'security code',
        'enter-code': 'Please enter the verification code',
        'code-tip': 'The verification code is 6 digits',
        'enter-pwd': 'Please enter a new password',
        'pwd-tip': 'The password length should be 1-16 bits',
        'pwd-again': 'Please enter a new password again',
        'pwd-different': 'The two passwords did not match'
    },
    'user': {
        'user-center': 'User Center',
        'modify-password': 'Modify Password',
        'modify-info': 'Modify Infomation',
        'modify-password-success': 'Modify Password Success.',
        'modify-info-success': 'Modify User Information Success.',
        'email-wrong-format': 'Wrong Email Format!',
        'phone-wrong-format': 'Wrong Phone Format!',
        'mobile-wrong-format': 'Wrong Mobile Format!',
        'userInfo': 'User information',
        'no': 'Employee No.',
        'noInfo': 'Employee No. should not be Empty',
        'nameRequired': 'Name should not be Empty',
        'emailRequired': 'Email should not be Empty',
        'name': 'Name',
        'loginName': 'Login Name',
        'loginNameInfo1': 'this username has been registered!',
        'loginNameInfo2': 'Login name should not be Empty!',
        'loginNameInfo3': 'Login name can only be letters, numbers or underline!',
        'loginNameInfo4': 'Login name at least four letters!',
        'loginNameInfo5': 'The max length can not exceed 50 letters',
        'newPassword': 'Password',
        'passwordInfo': 'Please leave blank if not modify',
        'newPasswordInfo1': 'Password should not be Empty!',
        'newPasswordInfo2': 'Password length is not less than three!',
        'confirmNewPassword': 'Confirm Password',
        'confirmNewPasswordInfo': 'Password input inconsistent!',
        'ent': 'Enterprise code',
        'entInfo': 'Enterprise Code should not be Empty!',
        'loginFlag': 'Account Enabled',
        'loginFlag1': 'Enabled',
        'loginFlag2': 'Disabled',
        'userAuthority': 'User permissions',
        'userRole': 'User Role',
        'userRoleInfo': 'If you modify your own role, you need to sign in again after the modification is successful',
        'nzTitle': 'Not required (click to expand)',
        'email': 'Email',
        'phone': 'Telephone',
        'mobile': 'Mobile Phone',
        'site': 'Stronghold',
        'defaultSite': 'Default Stronghold',
        'employeeNo': 'ERP user number',
        'employeeName': 'ERP employee name',
        'departmentNo': 'Department code',
        'departmentName': 'ERP department name',
        'ware': 'Default Warehouse',
        'remarks': 'Remarks',
        'userList': 'User List',
        'userAdd': 'Add Users',
        'userAdded': 'User Added',
        'userManage': 'User Management',
        'userEdit': 'User Edit',
        'editSuccess': 'Successfully Modified',
        'name-placeholder': 'Real Name',
        'loginName-placeholder': 'Login Name',
        'companyName': 'Supplier Name',
        'officeName': 'Department Name',
        'mobile-placeholder': 'Telephone Number',
        'operate': 'Operation',
        'edit': 'Edit',
        'delete': 'Delete',
        'warnInfo1': 'Are you sure to delete this user?',
        'current-account-no': 'Your current account number',
        'modifier': 'modifier',
        'login-password': 'login password',
        'login-password-tip': 'To protect the security of your account, you are advised to change your password regularly',
        'personal-data': 'personal data',
        'update-timely': 'If there is any change in your personal information, please update it',
        'old-password': 'old password',
        'new-password': 'new password',
        'confirm-new-password': 'Confirm new password',
        'user-tip': 'User default group error, please re-select'
    },
    'shared': {
        'all': 'All',
        'loading': 'Loading',
        'yes': 'Yes',
        'no': 'No',
        'page-total-count': '{{totalNum}} records,',
        'page-total-pages': '{{totalPage}} pages,',
        'page-goto': 'Goto',
        'page': '',
        'page-previous': 'Previous',
        'page-first': 'First',
        'page-next': 'Next',
        'page-last': 'Last',
        'page-each': '',
        'page-each-count': 'perPage',
        'table-colName': 'colName',
        'table-sort': 'sort',
        'table-width': 'width',
        'table-orderField': 'orderField',
        'table-orderType': 'orderType',
        'table-not-surported': 'sort not surported'
    },
    'home': {
        'common': {
            'anounce-list': 'Announcements',
            'anounce-detail': 'Detail',
            'message-list': 'Messages',
            'welcome': 'Welcome to SRM',
            'supplier': 'SRM',
            'ent': 'Ent:',
            'title-home': 'homepage',
            'title-login': 'login',
            'title-register': 'register',
            'title-anounce': 'Anouncement',
            'title-anounce-detail': 'Detail',
            'title-message': 'My Messages',
            'find-psd': 'Find password',
            'today-order': 'Today the order',
            'unconfirmed-order': 'Unconfirmed order',
            'overdue-order': 'Overdue order',
            'order-transit': 'Delivery order in transi',
            'get-code': 'get Code',
            'confirm-modification': 'confirm modification'

        },
        'login': {
            'select-language': 'Select Language:',
            'please-fill-userid': 'UserId',
            'please-fill-password': 'Password',
            'user-placeholder': 'UserId',
            'password-placeholder': 'Password',
            'login': 'Sign in',
            'login-now': 'Sign in Now',
            'logout': 'Sign Out',
            'platform': '云交货协同平台',
            'zhilink-home': 'zhilink.com',
            'zhilink-copyright': 'Surport:©{{year}} Zhilink(ShenZhen)Technology Co., Ltd.',
            'owner-website': 'homepage',
            'owner-copyright': '©CopyRight {{year}}',
            'owner-copyright2': '',
            'owner-phone': 'phone:',
            'owner-mail': 'mail:'
        },
        'register': {
            'form-title': 'Supplier Registration Information',
            'success': 'Information is submitted successfully, please wait for the audit. Please pay attention to the mailbox in the near future.'
        },
        'notfound': {
            'not-found-page': 'Sorry,The page is Missing!',
            'redirect-after-seconds': 'auto redirect after {{count}} seconds...',
            'redirect-imediately': 'click to redirect'
        },
        'anounce': {
            'title': 'Title',
            'date': 'Date',
            'more': 'more',
            'no-more-data': 'no more anouncements'
        },
        'message': {
            'title': 'Title',
            'please-select-category': 'category:',
            'all': 'All',
            'read': 'Read',
            'unread': 'Unread',
            'mark-as-read': 'Mark As Read'
        }
    },
    'other': {
        '温馨提示': 'Tips',
        '收货仓库': 'Warehouse receipt',
        '仓库储位': 'Warehouse storage',
        '已结案订单明细': 'Closed Order Details',
        '有答交日期在今天之前，': 'A cross there before today date,',
        '交总数量小于产品数量，': 'The total number of pay is less than the number of products,',
        '您确定要保存吗？': 'Are you sure you want to save it?'
    }
};



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/i18n/en-US.ts